(function () {
  var root = document.querySelector('.pictorel-app-container');
  if (!root || window.pctCartViewMode) return;

  var state = {
    lease: null,
    leasePromise: null
  };

  function hidden(name, id, value) {
    var form = document.getElementById('book-builder-form');
    if (!form) return null;
    var input = id ? document.getElementById(id) : null;
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      if (id) input.id = id;
      form.appendChild(input);
    }
    input.name = name;
    if (value !== undefined) input.value = value || '';
    return input;
  }

  function setCoreField(id, value) {
    var el = document.getElementById(id);
    if (el) el.value = value || '';
  }

  function api(path, body) {
    return fetch('/apps/pictoirel/' + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {})
    }).then(async function (response) {
      var text = await response.text();
      var payload = null;
      try { payload = text ? JSON.parse(text) : null; } catch (err) {}
      if (!response.ok) throw new Error((payload && payload.message) || text || 'Request failed.');
      return payload || {};
    });
  }

  function blueprintPath() {
    return (window.currentStorageFolder || '') + '/Layout_Blueprint.json';
  }

  function manifestPath() {
    return (window.currentStorageFolder || '') + '/Photo_Manifest.json';
  }

  function printBlueprintPath() {
    return (window.currentStorageFolder || '') + '/Print_Blueprint.json';
  }

  function deriveStatusPath(photo) {
    var explicit = photo && photo.statusPath;
    if (explicit) return explicit;
    var highresPath = String((photo && photo.highresPath) || '');
    return highresPath.replace(/\/full\.jpg$/i, '/status.json');
  }

  function inferRawPath(photo) {
    var rawPath = photo && (photo.rawPath || photo.sourcePath || photo.printPath);
    if (rawPath) return rawPath;
    if (!window.currentStorageFolder || !photo || !photo.photoId) return '';
    var match = String(photo.filename || photo.name || '').match(/\.([A-Za-z0-9]+)$/);
    var ext = match ? match[1].toLowerCase() : 'jpg';
    if (ext === 'jpeg') ext = 'jpg';
    return window.currentStorageFolder + '/raw/' + photo.photoId + '/original.' + ext;
  }

  function readyPhotos() {
    return (window.uploadedImagesData || []).filter(function (photo) {
      return photo && photo.status !== 'failed' && (photo.highres || photo.highresPath || photo.originalUrl || photo.previewUrl);
    });
  }

  window.pctBuildPhotoManifest = function () {
    return {
      version: 1,
      bookId: (state.lease && state.lease.book_id) || '',
      storageFolder: window.currentStorageFolder || '',
      blueprintVersion: hidden('properties[_Blueprint Version]', 'prop-blueprint-version').value || '1',
      photos: readyPhotos().map(function (photo, index) {
        var width = Number(photo.width || photo.originalWidth || 0);
        var height = Number(photo.height || photo.originalHeight || 0);
        var rawPath = inferRawPath(photo);
        return {
          photoId: photo.photoId || ('photo_' + index),
          filename: photo.filename || photo.name || ('Photo ' + (index + 1)),
          rawPath: rawPath,
          sourcePath: photo.sourcePath || rawPath,
          printPath: photo.printPath || rawPath,
          statusPath: deriveStatusPath(photo),
          thumbPath: photo.thumbPath || '',
          highresPath: photo.highresPath || '',
          thumbUrl: photo.thumb || photo.previewUrl || '',
          highresUrl: photo.highres || photo.originalUrl || '',
          status: 'ready',
          width: width,
          height: height,
          orientation: width > height ? 'landscape' : 'portrait'
        };
      })
    };
  };

  async function uploadManifest(manifest) {
    if (!window.firebaseRef || !window.firebaseStorage || !window.firebaseUploadBytes) {
      throw new Error('Photo manifest could not be saved.');
    }
    var ref = window.firebaseRef(window.firebaseStorage, manifestPath());
    var blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    await window.firebaseUploadBytes(ref, blob, { contentType: 'application/json' });
  }

  function applyLease(lease) {
    state.lease = lease;
    window.currentStorageFolder = lease.storage_folder;
    setCoreField('prop-book-id', lease.book_id);
    setCoreField('prop-storage-folder', lease.storage_folder);

    hidden('properties[_Builder Handle]', 'prop-builder-handle', lease.builder_handle);
    hidden('properties[_Line Fingerprint]', 'prop-line-fingerprint', lease.line_fingerprint);
    hidden('properties[_Blueprint Version]', 'prop-blueprint-version', lease.blueprint_version || '1');
    hidden('properties[_Blueprint Path]', 'prop-blueprint-path', blueprintPath());
    hidden('properties[_Photo Manifest Path]', 'prop-photo-manifest-path', manifestPath());
    hidden('properties[_Photo Manifest URL]', 'prop-photo-manifest-url', manifestPath());
    hidden('properties[_Print Blueprint Path]', 'prop-print-blueprint-path', printBlueprintPath());
    hidden('properties[_Print Blueprint Version]', 'prop-print-blueprint-version', window.pctPrintBlueprintVersion || '1');
    hidden('properties[_Line Signature]', 'prop-line-signature', '');
  }

  window.pctEnsureCartLease = function () {
    var variantInput = document.getElementById('prop-variant-id');
    var currentVariantId = variantInput ? variantInput.value : '';
    if (state.lease && String(state.lease.variant_id || '') === String(currentVariantId || '')) return Promise.resolve(state.lease);
    if (state.lease && String(state.lease.variant_id || '') !== String(currentVariantId || '')) {
      state.lease = null;
      state.leasePromise = null;
    }
    if (state.leasePromise) return state.leasePromise;

    var bookInput = document.getElementById('prop-book-id');
    var folderInput = document.getElementById('prop-storage-folder');
    state.leasePromise = api('builder-session-lease', {
      builder_handle: root.getAttribute('data-builder-mode') || 'relationship',
      customer_segment: root.getAttribute('data-customer-segment') || 'Guest_Orders',
      variant_id: currentVariantId,
      book_id: bookInput ? bookInput.value : '',
      storage_folder: folderInput ? folderInput.value : ''
    }).then(function (lease) {
      applyLease(lease);
      return lease;
    }).catch(function (err) {
      console.warn('Could not prepare edit-capable cart identity:', err);
      state.leasePromise = null;
      return null;
    });
    return state.leasePromise;
  };

  window.pctFinalizeCartIdentity = async function () {
    var lease = await window.pctEnsureCartLease();
    if (!lease) return { ok: false, editCapable: false };

    var manifest = window.pctBuildPhotoManifest();
    await uploadManifest(manifest);

    var createdAt = String(Math.floor(Date.now() / 1000));
    var versionInput = hidden('properties[_Blueprint Version]', 'prop-blueprint-version', lease.blueprint_version || '1');
    var fields = {
      book_id: lease.book_id,
      storage_folder: lease.storage_folder,
      blueprint_path: blueprintPath(),
      photo_manifest_path: manifestPath(),
      line_fingerprint: lease.line_fingerprint,
      blueprint_version: versionInput.value || '1',
      variant_id: String((document.getElementById('prop-variant-id') || {}).value || lease.variant_id || ''),
      builder_handle: lease.builder_handle,
      created_at: createdAt,
      lease_token: lease.lease_token
    };
    var signed = await api('sign-cart-line', fields);
    hidden('properties[_Line Signature]', 'prop-line-signature', signed.line_signature || '');
    hidden('properties[_Line Created At]', 'prop-line-created-at', createdAt);
    hidden('properties[_Blueprint Path]', 'prop-blueprint-path', fields.blueprint_path);
    hidden('properties[_Photo Manifest Path]', 'prop-photo-manifest-path', fields.photo_manifest_path);
    hidden('properties[_Photo Manifest URL]', 'prop-photo-manifest-url', fields.photo_manifest_path);
    hidden('properties[_Print Blueprint Path]', 'prop-print-blueprint-path', window.pctPrintBlueprintPath || printBlueprintPath());
    hidden('properties[_Print Blueprint Version]', 'prop-print-blueprint-version', window.pctPrintBlueprintVersion || '1');
    return { ok: true, editCapable: true };
  };

  var uploadBtn = document.getElementById('cloudinary-upload-btn');
  if (uploadBtn) {
    uploadBtn.addEventListener('click', function (event) {
      if (state.lease) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.pctEnsureCartLease().then(function () {
        if (window.pctRequestPhotoUpload) window.pctRequestPhotoUpload({ source: 'cart-edit' });
        else {
          var input = document.getElementById('firebase-file-input');
          if (input) input.click();
        }
      });
    }, true);
  }
})();
